import { Component, OnInit ,Output,Input,EventEmitter} from '@angular/core';
import { JobAssetService } from '../../../../../core/services/http/maintenance/job-asset.service';
import { MaintenanceCycle } from 'src/app/layout/models/smart-asset-recommendation';
import { AssetForRecommendationModel } from 'src/app/property/models/new-asset.model';
import { AssetMaintenanceCycleType, AssetMaintenanceCycleTypeOptions } from 'src/app/property/constants/asset-maintenance-cycle.enum';
import { AssetService } from 'src/app/core/services/http/agency-mgmt/asset.service';

@Component({
  selector: 'app-view-asset-details',
  templateUrl: './view-asset-details.component.html',
  styleUrls: ['./view-asset-details.component.scss']
})
export class ViewAssetDetailsComponent implements OnInit {

constructor(private JobAssetService: JobAssetService,private assetService:AssetService) { }
  @Output() closeEvent = new EventEmitter();
  @Output() acceptRecomandationEvent = new EventEmitter();
  @Output() rejectRecomandationEvent = new EventEmitter();
  @Output() snoozeRecomandationEvent = new EventEmitter();

  @Input() assetId!: string; 
  isAssetListLoading: boolean = false;
  assetDetails: AssetForRecommendationModel = new AssetForRecommendationModel();

  ngOnInit(): void {
    this.getAssetDetails(this.assetId);
  }
  public dismiss() {
      this.closeEvent.emit();
  }
  maintenanceCycleLabel(maintenanceCycle: AssetMaintenanceCycleType) {
      return typeof maintenanceCycle === 'number' && !isNaN(maintenanceCycle)
          ? AssetMaintenanceCycleTypeOptions.find(elem => elem.key == maintenanceCycle)?.value || ''
          : '';
    }

  getAssetDetails(assetId: string) {
      if(!assetId) return;
      this.assetService.getAssetForRecommendationView(assetId).subscribe({
        next: (res) => {
          this.assetDetails = res;
          this.isAssetListLoading = false;
          console.log("res",res)
        }
      })
    }

    acceptRecommendation(){
     this.acceptRecomandationEvent.emit();
    }
    rejectRecommendation(){
     this.rejectRecomandationEvent.emit();
    }

    snoozeRecommendation(){
     this.snoozeRecomandationEvent.emit();
    }

    getAssetMaintainanceType(assetCycle: MaintenanceCycle): string {
    switch (assetCycle) {
      case MaintenanceCycle.LessThanWeek:
        return 'before 4 days';
      case MaintenanceCycle.InMonth:
        return 'before 2 weeks';
      case MaintenanceCycle.InThreeMonths:
        return 'before 1 month';
      case MaintenanceCycle.InSixMonths:
        return 'before 3 months';
      case MaintenanceCycle.InYear:
      case MaintenanceCycle.WithinTwoYears:
        return '6 months before';

    }
    return 'Not considered';
  }
}
